import { StrictMode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { setupClientErrorHandling } from '@/api/api-client.ts';
import { client } from '@/api/generated/client.gen.ts';
import { PostHogProvider } from '@/lib/posthog.tsx';
import { queryClient } from '@/lib/query-client.ts';
import { router } from '@/router.tsx';
import '@/styles/globals.css';

setupClientErrorHandling(client);

async function enableMocking() {
  if (import.meta.env.VITE_ENABLE_MOCKS !== 'true') return;

  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <PostHogProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </PostHogProvider>
    </StrictMode>
  );
});
